import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import mdiSvgIcons from './vuetify/mdiSvgIcons';

Vue.use(Vuetify);

export default new Vuetify({
  icons: mdiSvgIcons,
});
